import React from "react";

const AchievementCard1 = (props) => {
  return (
    <div className="mx-8 mt-20 ">
      <div class="">
        <img
          className="w-full lg:h-[40vh]      border-gray-200 hover:border-8 hover:border-opacity-100"
          src={props.image}
          alt=""
        />
      </div>
      <div className="mt-8">
        <ul className="flex space-x-2">
          <li className="cursor-pointer hover:text-blue-400">
            {props.standard}
          </li>
          <li className="cursor-pointer hover:text-blue-400">|</li>
          <li className="cursor-pointer hover:text-blue-400">{props.name}</li>
        </ul>
        <h1 className="mt-6 cursor-pointer text-xl font-bold hover:text-blue-400">
          {props.title}
        </h1>
        <hr className="mt-4 border-blue-400" />
        <p className="mt-4 text-lg">{props.para}</p>
      </div>
    </div>
  );
};

export default AchievementCard1;
